import React, { Component } from "react";
import Table from "./../common/table";
import FormatDate from "./../common/formatDate";
import { Link, withRouter } from "react-router-dom";
import moment from "moment"
import { CopyToClipboard } from "react-copy-to-clipboard";
import Barcode from "react-barcode";

class COOItemsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: [],
    };
  }

  columns = [
    //   {path: '_id', label: 'Id'},
    {
      key: "checkbox",
      label: (
        <input
          type="checkbox"
          style={{
            width: "15px",
            height: "15px",
            marginTop: "0.4rem",
            borderRadius: 0,
          }}
          onChange={this.props.handleSelectAll}
        />
      ),
      content: (COOItem) => (
        <span className="icon-img sm-r-5" style={{ marginTop: "15px" }}>
          <input
            type="checkbox"
            style={{
              width: "15px",
              height: "15px",
              marginTop: "0.4rem",
              borderRadius: 0,
            }}
            onChange={this.props.handleCheckboxChange}
            value={COOItem._id}
            checked={this.props.checkedFields.includes(COOItem._id)}
          />
        </span>
      ),
    },
    {
      label: "Username",
      path: "username",
      content: (user) => (
        <span className="icon-img sm-r-5">
          <img
            style={{ width: "30px", height: "30px", borderRadius: "50%" }}
            src={user.user.imageSrc}
            alt=""
          />{" "}
          {user.user.username}
        </span>
      ),
    },
    { label: "RepairVendor", path: "repairVendor" },	
    { label: "SKU", path: "SKU" },	
    { label: "Serial", path: "serial" },
    { 
      label: "Serial", 
      content: (COOItem) => (
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'flex-start',
          gap: '8px',
          minWidth: 'auto',
          padding: '8px 4px 8px 8px',
          margin: '0px',
          width: 'fit-content'
        }}>

          
          {/* Copy to Clipboard Icon */}
          <CopyToClipboard 
            text={COOItem.serial || ""}
            onCopy={() => {
              this.handleCopySuccess(COOItem.serial);
              console.log('Code copied to clipboard:', COOItem.serial);
            }}
          >
            <button 
              className="copy-button"
              style={{
                background: this.state.copiedCode === COOItem.serial ? '#d4edda' : 'none',
                border: `1px solid ${this.state.copiedCode === COOItem.serial ? '#28a745' : '#ddd'}`,
                cursor: 'pointer',
                padding: '2px 4px',
                borderRadius: '3px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: this.state.copiedCode === COOItem.serial ? '#28a745' : '#007bff',
                fontSize: '12px',
                minWidth: '20px',
                height: '20px'
              }}
              title={this.state.copiedCode === COOItem.serial ? 'Copied!' : `Copy code: ${COOItem.serial}`}
            >
              <i className={this.state.copiedCode === COOItem.serial ? "fas fa-check" : "fas fa-copy"}></i>
            </button>
          </CopyToClipboard>
        </div>
      )
    },     
    { label: "Batch", path: "batch" },
    { label: "CoO item", path: "madeIn" },
    { label: "CoO from SAP", path: "COOfromDB" },    
    { label: "CoO on Box", path: "COOonBox" },            
    { label: "CoO from packinglist", path: "COOfromPackingList" },        
   // { label: "Description", path: "description" },
    { label: "CreatedOn", content: (user) => (
      <span>
        {moment(user.createdOn).format('lll')}
      </span>
    ), },	
    { label: "Note", path: "note" },
    { label: "Status", path: "status" },
  ];

  render() {
    const { COOitems, onSort, sortColumn } = this.props;

    return (
      <Table
        columns={this.columns}
        sortColumn={sortColumn}
        onSort={onSort}
        data={COOitems}
      />
    );
  }
}

export default COOItemsTable;
